import persistReducer from "redux-persist/lib/persistReducer";
import storage from "redux-persist/lib/storage";
import { NetworkTableconstant } from "./NetworkTableConstant";

const initialState = {
  NetworkTableList: [],
  NetworkTable: {
    isLoading: false,
  },
  AddChargingNetworkList: [],
  ChargingNetwork: {
    isLoading: false,
  },
  AddChargingNetworkEnableDisableList: [],
  AddChargingNetworkTable: {
    isLoading: false,
  },
  UpdateChargingNetworkList: [],
  UpdateNetwork: {
    isLoading: false,
  },
};

export const NetworkTableReducer = persistReducer(
  {
    storage,
    key: "NetworkTable",
    whitelist: [" NetworkTableList"],
  },

  (state = initialState, { type, payload }) => {
    switch (type) {
      case NetworkTableconstant.NETWORK_TABLE_REQUEST: {


        return {
          ...state,
          NetworkTableList: [],
          NetworkTable: {
            isLoading: true,
          },
        };
      }

      case NetworkTableconstant.NETWORK_TABLE_RESPONSE: {
        return {
          ...state,
          NetworkTableList: payload,
          NetworkTable: {
            isLoading: false,
          },
        };
      }

      // ****************post********
      case NetworkTableconstant.POST_ADD_CHARGING_NETWORK_REQUEST: {
        return {
          ...state,
          AddChargingNetworkList: [],
          ChargingNetwork: {
            isLoading: true,
          },
        };
      }

      case NetworkTableconstant.POST_ADD_CHARGING_NETWORK_RESPONSE: {
        return {
          ...state,
          AddChargingNetworkList: payload,
          ChargingNetwork: {
            isLoading: false,
          },
        };
      }

      //enable desable Reducer

      case NetworkTableconstant.ENABLE_DESABLE_CHARGING_NETWORK_REQUEST: {
        return {
          ...state,
          AddChargingNetworkEnableDisableList: [],
          AddChargingNetworkTable: {
            isLoading: true,
          },
        };
      }
      case NetworkTableconstant.ENABLE_DESABLE_CHARGING_NETWORK_RESPONSE: {
        return {
          ...state,
          AddChargingNetworkEnableDisableList: payload,
          AddChargingNetworkTable: {
            isLoading: false,
          },
        };
      }

      //update charging network reducer
      case NetworkTableconstant.UPDATE_CHARGING_NETWORK_REQUEST: {
        return {
          ...state,
          UpdateChargingNetworkList: [],
          UpdateNetwork: {
            isLoading: true,
          },
        };
      }

      case NetworkTableconstant.UPDATE_CHARGING_NETWORK_RESPONSE: {
        return {
          ...state,
          UpdateChargingNetworkList: payload,
          UpdateNetwork: {
            isLoading: false,
          },
        };
      }

      default:
        return state;
    }
  }
);
